import type { UserInfo, UserToken } from '#/entity';
import apiClient from '../apiClient';

export interface SignInReq {
  username: string;
  password: string;
}

export interface SignInRes {
  access_token: string;
  token_type: string;
}

export enum UserApi {
  SignIn = '/auth/token',
  GetProfile = '/admin/users/me',
}

const signIn = (data: SignInReq): Promise<UserToken> =>
  apiClient
    .post<SignInRes>(
      { url: UserApi.SignIn, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
      data,
    )
    .then((res) => ({
      accessToken: `${res.token_type} ${res.access_token}`,
    }));

const getProfile = (accessToken?: string) =>
  apiClient.get<UserInfo>({
    url: UserApi.GetProfile,
    headers: accessToken ? { Authorization: accessToken } : undefined,
  });

export default {
  signIn,
  getProfile,
};
